import { connect } from 'react-redux'
import { StorePerformancePageComponent } from './StorePerformancePageComponent'
import { State } from '../core/reducers'

const mapStateToProps = (state: State) => ({
  // 如果需要从state映射props，可以在这里添加
})

const mapDispatchToProps = {
  // 如果需要dispatch actions，可以在这里添加
}

export const StorePerformancePageContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(StorePerformancePageComponent)